import { computed, effect, signal } from '@preact/signals';

const STORAGE_KEY = 'cart';

/** @type {import('@preact/signals').Signal<import('@/api/types').CartItem[]>} */
export const cart = signal(loadFromStorage());

export const cartCount = computed(() => cart.value.reduce((s, i) => s + i.quantity, 0));
export const cartTotal = computed(() =>
  cart.value.reduce((s, i) => s + (i.price ?? 0) * i.quantity, 0),
);
export const cartPositions = computed(() => cart.value.length);

// Сохраняем в localStorage при любом изменении корзины.
effect(() => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(cart.value));
  } catch {
    // ignore quota
  }
});

function loadFromStorage() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  } catch {
    return [];
  }
}

function findIndex(product) {
  return cart.value.findIndex(
    (i) => i.productId === product.id || i.externalId === product.external_id,
  );
}

export function getCartQty(productId) {
  const item = cart.value.find((i) => i.productId === productId || i.externalId === productId);
  return item ? item.quantity : 0;
}

export function setCartItem(product, qty) {
  const idx = findIndex(product);
  const next = [...cart.value];
  if (qty <= 0) {
    if (idx >= 0) next.splice(idx, 1);
  } else if (idx >= 0) {
    next[idx] = {
      ...next[idx],
      quantity: qty,
      price: product.opt_price ?? product.price,
    };
  } else {
    next.push({
      productId: product.id,
      externalId: product.external_id,
      sku: product.sku,
      name: product.name,
      price: product.opt_price ?? product.price,
      quantity: qty,
      available: product.total_available ?? 0,
    });
  }
  cart.value = next;
}

export function addToCart(product, quantity) {
  const current = getCartQty(product.id);
  setCartItem(product, current + quantity);
}

export function removeFromCart(product) {
  setCartItem(product, 0);
}

export function clearCart() {
  cart.value = [];
}

export function updateQty(index, qty) {
  const next = [...cart.value];
  if (!next[index]) return;
  if (qty <= 0) next.splice(index, 1);
  else next[index] = { ...next[index], quantity: qty };
  cart.value = next;
}

export function removeAt(index) {
  const next = [...cart.value];
  next.splice(index, 1);
  cart.value = next;
}
